import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { Language } from '@app/shared/models';
import { LanguageFacade } from '@app/store/language';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router, RouterLink } from '@angular/router';
import { MaterialSharedModule } from '@app/shared/modules/material-shared.module';
import { UiFacade } from '@app/store/ui';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '@app/shared/modules/shared.module';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
  selector: 'app-control-header',
  templateUrl: './control-header.component.html',
  styleUrl: './control-header.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    MaterialSharedModule,
    AngularSvgIconModule,
    RouterLink,
    MatMenuModule,
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ControlHeaderComponent implements OnInit {
  Language = Language;
  currentLanguage = signal(Language.EN);
  private translate = inject(TranslateService);
  languageOptions = signal<any[]>([]);

  constructor(
    private readonly languageFacade: LanguageFacade,
    private readonly uiFacade: UiFacade,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.updateLanguageOptions();
    
    this.translate.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.updateLanguageOptions();
      });

    this.languageFacade.activeLanguage$
      .pipe(untilDestroyed(this))
      .subscribe((language: Language) => {
        this.currentLanguage.set(language);
      });
  }

  private updateLanguageOptions(): void {
    const options = this.languageFacade.getLanguageOptions();
    this.languageOptions.set(options.map(opt => ({
      ...opt,
      label: this.translate.instant(opt.label)
    })));
  }

  onMenuClick(): void {
    this.uiFacade.toggleSidenav();
  }

  onLanguageSelect(language: Language): void {
    this.currentLanguage.set(language);
    this.languageFacade.setActiveLanguage(language);
    this.languageFacade.updateUserPreferredLanguage(language);
  }

  getCurrentLanguageOption() {
    return this.languageOptions().find(option => option.value === this.currentLanguage()) || this.languageOptions()[0];
  }
}
